// AUTO-GENERATED: 2025-10-28T19:10:34.719531Z
// 🍣 Japanese recipes

export const japaneseRecipes = [
{
    name: "Chicken Teriyaki",
    cuisine: "Japanese",
    ingredients: ["chicken thighs", "scallions", "ginger"],
    sauces: ["soy sauce", "mirin", "sake", "sugar", "sesame seeds"],
    instructions: "Mix soy sauce, mirin, sake, and sugar to make teriyaki sauce. Pan-fry chicken skin-side down until golden, flip. Add sauce, simmer 8-10 minutes, basting frequently until chicken is glazed and cooked through. Slice chicken, drizzle with remaining sauce. Garnish with sesame seeds and sliced scallions. Serve over rice with steamed vegetables.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Ramen",
    cuisine: "Japanese",
    ingredients: ["ramen noodles", "pork belly", "eggs", "scallions", "nori", "bamboo shoots"],
    sauces: ["soy sauce", "miso paste", "chicken broth", "sesame oil"],
    instructions: "Simmer chicken broth with soy sauce and miso paste. Marinate and braise pork belly, slice thin. Soft boil eggs, peel, marinate in soy sauce. Cook ramen noodles, drain. Assemble bowls: noodles, pour hot broth over. Top with pork slices, halved eggs, bamboo shoots, scallions, nori sheet. Drizzle with sesame oil. Serve immediately.",
    time: "40 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Sushi Rolls",
    cuisine: "Japanese",
    ingredients: ["sushi rice", "nori sheets", "cucumber", "avocado", "crab stick"],
    sauces: ["rice vinegar", "soy sauce", "wasabi", "pickled ginger"],
    instructions: "Cook sushi rice, mix with rice vinegar and sugar while warm. Place nori on bamboo mat, spread thin layer of rice leaving 1-inch border. Add cucumber, avocado, crab stick in a line. Roll tightly using mat. Wet knife, slice into 8 pieces. Serve with soy sauce, wasabi, and pickled ginger.",
    time: "45 min",
    difficulty: "Hard",
    points: 100,
    servings: 2
  },
{
    name: "Miso Soup",
    cuisine: "Japanese",
    ingredients: ["tofu", "wakame seaweed", "scallions"],
    sauces: ["miso paste", "dashi broth"],
    instructions: "Bring dashi broth to gentle simmer. Add cubed tofu and rehydrated wakame seaweed. Simmer 2-3 minutes. Turn off heat. Dissolve miso paste in small amount of hot broth, then stir back into pot. Do not boil after adding miso. Ladle into bowls, garnish with sliced scallions. Serve immediately.",
    time: "15 min",
    difficulty: "Easy",
    points: 25,
    servings: 2
  },
{
    name: "Tempura",
    cuisine: "Japanese",
    ingredients: ["shrimp", "sweet potato", "zucchini", "mushrooms", "flour", "eggs"],
    sauces: ["tempura sauce", "soy sauce", "dashi", "mirin"],
    instructions: "Make batter: ice-cold water, flour, egg (keep lumpy). Heat oil to 350°F. Dip vegetables and shrimp in batter, fry in batches until light golden, 2-3 minutes. Don't overcrowd. Drain on paper towels. Make dipping sauce with dashi, soy sauce, and mirin. Serve tempura immediately while hot and crispy.",
    time: "30 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Tonkatsu",
    cuisine: "Japanese",
    ingredients: ["pork chops", "eggs", "flour", "panko breadcrumbs", "cabbage"],
    sauces: ["tonkatsu sauce", "worcestershire sauce"],
    instructions: "Pound pork chops to even thickness. Season with salt and pepper. Coat in flour, dip in beaten egg, press into panko breadcrumbs. Deep fry at 350°F for 5-6 minutes until golden and crispy. Drain on paper towels. Slice into strips. Serve with shredded cabbage, rice, and tonkatsu sauce for drizzling.",
    time: "25 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Gyoza",
    cuisine: "Japanese",
    ingredients: ["ground pork", "cabbage", "garlic", "ginger", "scallions", "gyoza wrappers"],
    sauces: ["soy sauce", "rice vinegar", "sesame oil", "chili oil"],
    instructions: "Mix ground pork with finely chopped cabbage, garlic, ginger, scallions, soy sauce, sesame oil. Place spoonful in gyoza wrapper, fold in half, pleat edges. Heat oil in pan, arrange gyoza flat-side down. Fry until bottom is golden. Add water, cover immediately. Steam 5-6 minutes. Remove lid, cook until water evaporates and bottom crisps again. Serve with dipping sauce.",
    time: "45 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Okonomiyaki",
    cuisine: "Japanese",
    ingredients: ["cabbage", "flour", "eggs", "pork belly", "scallions"],
    sauces: ["okonomiyaki sauce", "japanese mayonnaise", "bonito flakes", "seaweed"],
    instructions: "Make batter with flour, eggs, and dashi. Mix in shredded cabbage and scallions. Heat pan, add pork belly strips. Pour batter on top. Cook 4-5 minutes until bottom is golden. Flip carefully. Cook 4-5 more minutes. Top with okonomiyaki sauce, mayo drizzle, bonito flakes, and aonori seaweed. Slice and serve hot.",
    time: "25 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Yakitori",
    cuisine: "Japanese",
    ingredients: ["chicken thighs", "scallions"],
    sauces: ["soy sauce", "mirin", "sake", "sugar"],
    instructions: "Cut chicken into bite-sized pieces. Thread onto bamboo skewers alternating with scallion pieces. Mix soy sauce, mirin, sake, and sugar to make tare sauce. Grill skewers over high heat, turning frequently. Brush with tare sauce multiple times while grilling. Cook until chicken is charred and caramelized. Serve hot with extra sauce.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Udon Noodle Soup",
    cuisine: "Japanese",
    ingredients: ["udon noodles", "tofu", "mushrooms", "scallions", "fish cakes"],
    sauces: ["soy sauce", "mirin", "dashi broth"],
    instructions: "Bring dashi broth to simmer with soy sauce and mirin. Add sliced mushrooms and fish cakes. Cook udon noodles according to package, drain. Place noodles in bowls, ladle hot broth over. Add cubed tofu. Garnish with sliced scallions and nori. Optionally add soft-boiled egg and tempura. Serve immediately.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  }
];
